var _desc, _defs, _path, _use, _path2, _polygon, _g, _g2, _polygon2, _g3, _path3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIllustrationVw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "389px",
    height: "319px",
    viewBox: "0 0 389 319",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "0%",
    y2: "151.367293%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2B2B",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2B2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44.0%",
    y: "-27.0%",
    width: "188.1%",
    height: "154.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "24.5674172%",
    cy: "30.1344167%",
    fx: "24.5674172%",
    fy: "30.1344167%",
    r: "102.816702%",
    gradientTransform: "translate(0.245674,0.301344),scale(1.000000,0.626818),rotate(55.911273),translate(-0.245674,-0.301344)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.188018176,
    offset: "48.3916614%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0.47164917 18.1638876 72.1395985 59.4708029 72.1395985 132.5 0.47164917 91.1930847"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "81.4010239 41.4298248 72.1020508 47.0010376 0.473365784 5.73143005 9.77233887 0.295410156"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "81.0005077 41.25 71.9317627 46.8725586 71.9317627 69.9017557 81.0005077 64.2791971"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.1145974%",
    y1: "20.1468825%",
    x2: "14.3604909%",
    y2: "99.3219229%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2B2B",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2B2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "55.2856445 206.740151 160.569869 268.573743 240.618591 221.798096 240.618591 129.386902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "126.437378 72.6596967 232.40921 133.717041 232.230072 216.467438 126.437378 155.627441"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "55.625 196.875 160.625 256.875 160.625 268.75 55.625 207.916667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "55.2856445 196.495725 160.569869 257.704318 232.291989 216.72612 126.172175 155.728117"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-12",
    points: "126.172175 72.5613272 232.7064 134.18433 241.039861 129.573663 134.505637 67.95066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Desktop-Home",
    transform: "translate(-727.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(490.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_illustration",
    transform: "translate(141.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VW_service_icon"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.590707,124.622951 L282.940533,124.260844 L223.803492,221.463803 C222.654344,223.352644 219.921988,224.891583 217.725286,224.901014 L141.370441,225.228799 C139.162688,225.238276 138.30396,223.715667 139.453665,221.82591 L198.590707,124.622951 Z",
    id: "Rectangle-3",
    fillOpacity: 0.119999997,
    fill: "url(#linearGradient-1)",
    transform: "translate(210.647471, 174.748046) rotate(30.000000) translate(-210.647471, -174.748046) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    filter: "url(#filter-2)",
    strokeWidth: 1,
    transform: "translate(119.375000, 93.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#E0F0FB",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-3)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-4"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C3E1F8",
    strokeWidth: 1,
    d: "M0.97164917,19.0291744 L71.6395985,59.7597245 L71.6395985,131.634713 L0.97164917,90.9041632 L0.97164917,19.0291744 Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#86C3F1",
    points: "81.0223389 54.1575623 72.1020508 59.5010376 72.1020508 132.524414 81.0223389 127.316132"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0382E1",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.24000001,
    fill: "#2E2B2B",
    xlinkHref: "#path-5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0382E1",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.12,
    fill: "#2E2B2B",
    xlinkHref: "#path-6"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#0382E1",
    points: "0.625 5.625 72.2929494 46.9319153 72.2929494 69.9611124 0.625 28.6541971"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.750000, 43.750000)",
    fillRule: "nonzero",
    fill: "#0382E1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875,2.49439295 L1.875,36.7848041 C1.875,38.4034643 3.09450368,40.4993085 4.50658957,41.3051881 L51.7443169,68.2638338 C52.7149918,68.8177995 53.1367493,68.5742101 53.1367493,67.4667194 L53.1367493,33.1763082 C53.1367493,31.5576481 51.9172456,29.4618039 50.5051597,28.6559242 L3.26743236,1.69727856 C2.29675743,1.14331285 1.875,1.38690225 1.875,2.49439295 Z M0.625,2.49439295 C0.625,0.426421828 2.08388541,-0.417411789 3.88701096,0.611634813 L51.1247383,27.5702805 C52.9262972,28.598433 54.3867493,31.1084501 54.3867493,33.1763082 L54.3867493,67.4667194 C54.3867493,69.5346905 52.9278639,70.3785242 51.1247383,69.3494776 L3.88701096,42.3908319 C2.08545205,41.3626794 0.625,38.8526622 0.625,36.7848041 L0.625,2.49439295 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "28.125 55.3125 28.125 14.468751 26.875 14.468751 26.875 55.3125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "15 47.8125 15 6.96875095 13.75 6.96875095 13.75 47.8125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "0.689010595 30.85784 53.4390691 60.9781766 54.0588929 59.8926728 1.30883436 29.7723362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "0.397336218 20.85784 53.1473947 50.9781766 53.7672185 49.8926728 1.01715998 19.7723362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "0.397336218 10.23284 53.1473947 40.3531766 53.7672185 39.2676728 1.01715998 9.14733622"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "41.25 62.8125 41.25 21.968751 40 21.968751 40 62.8125"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125,31.1913996 C25.1960678,32.3710651 26.875,31.6484409 26.875,29.577373 C26.875,27.5063052 25.1960678,24.8710651 23.125,23.6913996 C21.0539322,22.511734 19.375,23.2343583 19.375,25.3054261 C19.375,27.3764939 21.0539322,30.011734 23.125,31.1913996 Z",
    id: "Oval",
    fillOpacity: 0.719999969,
    fill: "#2E2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50,47.4413996 C52.0710678,48.6210651 53.75,47.8984409 53.75,45.827373 C53.75,43.7563052 52.0710678,41.1210651 50,39.9413996 C47.9289322,38.761734 46.25,39.4843583 46.25,41.5554261 C46.25,43.6264939 47.9289322,46.261734 50,47.4413996 Z",
    id: "Oval",
    fillOpacity: 0.719999969,
    fill: "#2E2B2B"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "computer",
    transform: "translate(143.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.375414,79.5331367 L378.82746,146.477331 L243.617534,220.454153 C241.99758,221.340472 239.385394,221.31861 237.781022,220.404165 L126.135626,156.76959 C124.532164,155.855664 124.544287,154.39696 126.165488,153.509959",
    id: "Rectangle-3",
    fillOpacity: 0.119999997,
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.599999964,
    fill: "#FFFFFF",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.72,
    fill: "#FFFFFF",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.72,
    fill: "#FFFFFF",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2E2B2B",
    points: "136.496745 89.4721543 224.88183 140.130855 224.88183 202.093161 136.496745 151.43446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.48,
    fill: "#FFFFFF",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.48,
    fill: "#FFFFFF",
    xlinkHref: "#path-12"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationVw);
export default __webpack_public_path__ + "static/media/home_illustration_vw.a81d1c295afaa7e6db399423b92dcecc.svg";
export { ForwardRef as ReactComponent };